import { ResolvedPackSort, resolvePackSortConfig } from '@/utils/pack-sort';
import { useDynamicConfigValue } from '@/hooks/use-dynamic-config-value';
import { useMemo } from 'react';

export const usePackSortConfig = (): ResolvedPackSort => {
  const config = useDynamicConfigValue('pack_sort_config');
  const { customOrder, sortOrder } = resolvePackSortConfig(config);

  const customOrderKey = JSON.stringify(customOrder);

  return useMemo(
    () => ({ customOrder: JSON.parse(customOrderKey) as string[], sortOrder }),
    [sortOrder, customOrderKey],
  );
};
